/**
 * Entra-login voor het beheerportaal.
 *
 * Dit is de echte SSO-route: auth code met PKCE in de browser, MFA en
 * Conditional Access gewoon van toepassing. Dat telefoons dit niet kunnen is
 * een aparte kwestie — die spreken CardDAV en gebruiken een app-wachtwoord.
 */

import { PublicClientApplication, type Configuration, type SilentRequest } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined;
const apiScope = import.meta.env.VITE_API_SCOPE as string | undefined;

export const apiBase = ((import.meta.env.VITE_API_BASE as string | undefined) ?? '').replace(/\/+$/, '');

/** Ontbrekende configuratie is geen crash maar een leesbare melding. */
export const configError =
  !tenantId || !clientId || !apiScope
    ? 'Het portaal is niet geconfigureerd. Vul VITE_ENTRA_TENANT_ID, VITE_ENTRA_CLIENT_ID en ' +
      'VITE_API_SCOPE in client/.env en bouw opnieuw.'
    : null;

const configuration: Configuration = {
  auth: {
    clientId: clientId ?? 'niet-geconfigureerd',
    authority: `https://login.microsoftonline.com/${tenantId ?? 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // sessionStorage in plaats van localStorage: een gedeelde beheerwerkplek
    // laat dan geen sessie achter na het sluiten van de browser.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(configuration);

export const loginRequest = {
  scopes: apiScope ? [apiScope] : [],
};

export function silentRequest(account: SilentRequest['account']): SilentRequest {
  return { scopes: loginRequest.scopes, account };
}
